'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _immutable = require('immutable');

var _TransmuteCollection = require('./TransmuteCollection');

var jsToValueSeq = function jsToValueSeq(subject) {
  return (0, _immutable.Seq)(subject).valueSeq();
};

_TransmuteCollection.valueSeq.implement(Array, jsToValueSeq);
_TransmuteCollection.valueSeq.implementInherited(_immutable.Iterable, function (subject) {
  return subject.valueSeq();
});
_TransmuteCollection.valueSeq.implement(Object, jsToValueSeq);

exports.default = _TransmuteCollection.valueSeq;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/transmute/static-2.3/internal/_valueSeq.js
// module id = 367
// module chunks = 0 1